import React from 'react'
import styled from 'styled-components'
import Box from '@components/Box'
import { STypographyTag } from '@components/Typography'
import { IItem } from './types'

const SItem = styled.a`
  display: flex;
  width: 33%;
  margin-bottom: 20px;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  user-select: none;
  text-decoration: none;

  ${STypographyTag} {
    transition: 0.3s;
  }

  :hover ${STypographyTag} {
    color: ${(props) => props.theme.colors.gray};
  }
`

const HeaderEcosystemMenuItem: React.FC<IItem> = ({ src, href, text, alt }) => {
  return (
    <SItem href={href} target="_blank">
      <Box mb="8px">
        <img src={src} alt={alt} />
      </Box>
      <STypographyTag color="graphite">{text}</STypographyTag>
    </SItem>
  )
}

export default HeaderEcosystemMenuItem
